import { useMutation, useQueryClient} from '@tanstack/react-query';
import { updateTicket } from '../../api/TICKET/ticket';

export const useUpdateTicket = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, ticketData }) => updateTicket(id, ticketData),
        onSuccess: (_, variables) => {
            // Invalidate queries to refresh data
            queryClient.invalidateQueries({ queryKey: ['tickets'] });
            queryClient.invalidateQueries({ queryKey: ['ticket', variables.id] });
        },
    });
};